import { useQuery } from '@tanstack/react-query';
import { getUserPurchase } from '@/services/purchases';

/**
 * Returns whether the current user has already purchased a given model.
 * Only queries when both modelId and userId are provided (logged-in users only).
 * Anonymous users always get hasPurchased = false (they pay each time).
 */
export function useDownloadAccess(
  modelId: string | null | undefined,
  userId: string | null | undefined,
) {
  const { data: hasPurchased = false, isLoading } = useQuery({
    queryKey: ['purchase', modelId, userId],
    queryFn: () => getUserPurchase(modelId!, userId!),
    enabled: !!modelId && !!userId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return { hasPurchased, isLoading };
}
